

















































































































































































































































































































































































































































import { Component, Vue, Prop, PropSync, Watch } from 'vue-property-decorator';
import infoTabs from '@/layouts/parent/BTabsParent.vue';
import secondaryNav from '@/components/navbars/secondary-nav.vue';
import {
	NotificationsApi,
	ProductsApi,
	TanksApi,
	Tank,
	SensorsApi,
	SimproJobDetails,
	Product,
	ProductSimProJobTypeEnum,
	ProductStatus,
	Entities,
} from '@/api';
import FuelCorrections from '@/components/fuel-corrections.vue';
import TankChartAdmin from '@/components/charts/tank-chart.vue';
import ManageEventSubscriptions from '@/components/manage-event-subscriptions.vue';
import EventSubscriptions from '@/components/tables/event-subscriptions.vue';

import ConfirmModal from '@/components/display/confirm-modal.vue';
import DataTable from '@/components/datatable.vue';
import Toast from '@/components/display/toast.vue';
import TitleMixin from '@/mixins/title-mixin';
import routerLinkButton from '@/components/elements/buttons/router-link-button.vue';
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css';
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker';
import moment from 'moment';
import { TankHeightVolume } from '@/typings/fuel-volume-calculator';
import TankCurrentStatus from '@/components/charts/tank-currentStatus.vue';
import InstallTankModal from '@/pages/account/products/fuel/tanks/install.vue';
import ProvisionTankModal from '@/pages/account/products/fuel/tanks/provision.vue';
import Notifications from '@/components/tables/notifications.vue';
import EventSubscriptionChangeLog from '@/components/tables/event-subscription-change-log.vue';
import DeletedEventSubscriptionAudits from '@/components/tables/deletedEventSubscriptionAudits.vue';
import FuelAllocationsTab from './FuelAllocationsTab.vue';
import LocationRow from '@/components/display/information-rows/location-row.vue';
import LastCheckInTag from '@/components/display/information-rows/last-check-in-tag.vue';
import LiveAtRow from '@/components/display/information-rows/live-at-row.vue';
import ChangelogLink from '@/components/display/changelog-link.vue';
import { isLastEntityOnProduct } from '@/common/EntityUtils';
import {
	StatusChangeReasonsCancel,
	StatusChangeReasonsLastEntity,
	StatusChangeReasonsRemoval,
} from '@/common/Constants';
import ConfirmDraftActionbar from '@/components/confirm-draft-actionbar.vue';
import { formattedStatus } from '@/common/StatusUtil';

Vue.component('VueCtkDateTimePicker', VueCtkDateTimePicker);
@Component({
	computed: {
		Entities() {
			return Entities;
		},
		ProductStatus() {
			return ProductStatus;
		},
	},
	methods: { formattedStatus },
	components: {
		ConfirmDraftActionbar,
		ChangelogLink,
		LastCheckInTag,
		LiveAtRow,
		LocationRow,
		Notifications,
		FuelCorrections,
		routerLinkButton,
		secondaryNav,
		TankChartAdmin,
		DataTable,
		ConfirmModal,
		Toast,
		infoTabs,
		TankCurrentStatus,
		InstallTankModal,
		ProvisionTankModal,
		EventSubscriptionChangeLog,
		ManageEventSubscriptions,
		EventSubscriptions,
		DeletedEventSubscriptionAudits,
		FuelAllocationsTab,
	},
	mixins: [TitleMixin],
})
export default class TankView extends Vue {
	@Prop()
	public product?: Product;
	@Prop()
	public tankId?: number;
	@Prop()
	public productPlan?: string;
	@Prop()
	public simproJobs?: SimproJobDetails[];

	public submitStatus: 'ERROR' | 'PENDING' | 'OK' | null = null;
	public currentPage = 1;
	public perPage = 20;
	public rawDataDate = moment()
		.utc()
		.format('YYYY-MM-DD')
		.toString();
	public loading = true;
	public click?: (item: any, index: number, e: Event) => void;
	public filters?: any;
	public tankState = {};
	public calculatedTank: Promise<TankHeightVolume | Error> = {
		volume: 0,
		maxVolume: 0,
		minVolume: 0,
		height: 0,
	};
	public rawData: any[] | null = [];
	public sentFields: any[] | null = [
		{ key: 'user.email', label: 'Sent To' },
		{ key: 'data.type', label: 'Name' },
		{ key: 'data.channel', label: 'Channels' },
		{ key: 'created_at', label: 'Date Sent' },
	];
	public readyForSignOff() {
		if (
			this.tank.status === 'install' &&
			![
				this.tank.fuelType,
				this.tank.formulaId,
				this.tank.nominalVolume,
				this.tank.fluctuation,
				this.tank.fuelType,
				this.tank.fuelType,
				this.tank.transceiverId,
				this.tank.sensor,
				this.productPlan,
			].includes(null)
		) {
			return false;
		} else {
			return true;
		}
	}

	public transceiverFields: any[] | null = [
		{ key: 'transceiver.id', label: 'Id', sortable: true },
		{ key: 'label', label: 'Vat', sortable: true },
		{ key: 'transceiver.createdAt', label: 'Created', sortable: true },
		{ key: 'transceiver.serialNumber', label: 'Serial Number', sortable: true },
		{ key: 'transceiver.imei', label: 'IMEI', sortable: true },
	];

	public form = { type: '', users: [] };

	public users: any[] | null = null;
	public fields: any[] | null = [
		{ key: 'created_at', label: 'Date Sent' },
		{ key: 'from', label: 'From' },
		{ key: 'to', label: 'To' },
		{ key: 'user.name', label: 'By' },
	];

	public auditFields: any[] | null = [
		{ key: 'id', label: 'ID' },
		{ key: 'created_at', label: 'Date Sent' },
		{ key: 'fields', label: 'fields' },
		{ key: 'old_values', label: 'From' },
		{ key: 'new_values', label: 'To' },
		{ key: 'user.name', label: 'By' },
	];

	public tank: Tank = null;
	private api: TanksApi;
	private sensorApi: SensorsApi;
	private notificationsApi: NotificationsApi;
	private productApi: ProductsApi;

	constructor() {
		super();
		this.api = new TanksApi();
		this.sensorApi = new SensorsApi();
		this.notificationsApi = new NotificationsApi();
		this.productApi = new ProductsApi();
	}

	public isChimera() {
		return this.product?.tanks?.some(
			tank =>
				tank?.transceiver?.isChimera ||
				tank?.transceiver?.isChimeraV1 ||
				tank?.transceiver?.isChimeraV3,
		);
	}

	public pageTitle() {
		return `Tank | ${this.tank.product ? this.tank.product.name : ''}`;
	}

	public async loadTank() {
		const tankId = this.tankId;
		try {
			const { data } = await this.api.getTankById(parseInt(tankId, 10), {
				params: {
					include:
						'product,product.site,product.site.org,transceiver.site,audits,audits.user,files,' +
						'sensor.transceiver.site,corrections,formula,corrections.user,distributor,dielectric,entitylocation,entitystatuschanges',
				},
			});
			this.tank = data;
		} catch (e) {
			console.log(e);
			this.tank = null;
		}
		try {
			if (this.tank && this.tank.sensor !== null) {
				const sensorData = await this.sensorApi.getSensorProperties(
					parseInt(this.tank.sensor.id, 10),
				);
				const tankSensor = sensorData.data.data[0].data;
				if (tankSensor) {
					this.tank.sensor.emptyCapacitance = sensorData.data.data[0].data.emptyCapacitance;
					this.tank.sensor.probeLength = sensorData.data.data[0].data.length;
					this.tank.sensor.dimension = sensorData.data.data[0].data.dimension;
				}
			}
		} catch (e) {
			console.log(e);
		} finally {
			this.loading = false;
		}
	}

	public async loadCurrentState() {
		try {
			const response = await this.api.tanksTankIdCurrentStateGet(this.tank.id, {});
			this.tankState = response.data.data;
		} catch (e) {
			console.log(e);
		}
	}

	private hasSimproRemovalJobReason() {
		return this.simproJobs?.find((simproJob: SimproJobDetails) => {
			return simproJob.jobType === ProductSimProJobTypeEnum.Remove && simproJob.reason != null;
		});
	}

	public statusChangeReasonOptions(removal: boolean) {
		return this.hasSimproRemovalJobReason()
			? []
			: (isLastEntityOnProduct(this.product)
					? StatusChangeReasonsLastEntity
					: removal
					? StatusChangeReasonsRemoval
					: StatusChangeReasonsCancel
			  ).map(val => ({ value: val, text: val }));
	}

	public async deactivateTank(params: { modalId: string; actionReason?: string | null }) {
		try {
			let response = await this.api.removeTank(parseInt(this.tankId, 10), {
				actionReason: params.actionReason ?? undefined,
			});
		} catch (e) {
			let error = 'Tank not deactivated ' + JSON.stringify(e.response.data.errors, null, 2);
			new Toast().makeToast(error, 'Error Deactivating Tank', 'danger', false);
			this.submitStatus = 'ERROR';
			return;
		}
		setTimeout(() => {
			new Toast().makeToast('Tank Deactivated', 'Tank Deactivated', 'success', false);
			this.$emit('loadProduct', this.tank.id);
			this.loadTank();
			this.$bvModal.hide(params.modalId);
		}, 1000);
	}

	public async cancelTank(params: { modalId: string; actionReason?: string | null }) {
		try {
			let response = await this.api.cancelTank(parseInt(this.tankId, 10), {
				actionReason: params.actionReason ?? undefined,
			});
		} catch (e) {
			const error = 'Tank not cancelled ' + JSON.stringify(e.response.data.errors, null, 2);
			new Toast().makeToast(error, 'Error Cancelling Tank', 'danger', false);
			this.submitStatus = 'ERROR';
			return;
		}
		setTimeout(() => {
			new Toast().makeToast('Tank Cancelled', 'Tank Cancelled', 'success', false);
			this.$emit('loadProduct', this.tank.id);
			this.loadTank();
			this.$bvModal.hide(params.modalId);
		}, 1000);
	}

	@Watch('tankId')
	public async created() {
		this.loading = true;
		await this.loadTank();
		await this.loadCurrentState();
		this.loading = false;
	}

	public async moveTankToSignOff() {
		let response;
		try {
			response = this.productApi.changeProductStatus(this.tank.productId, 'tanks', this.tankId, {
				newStatus: 'sign-off',
			});
		} catch (e) {
			let error;
			if (e.response) {
				error = 'Tank not moved to sign off ' + JSON.stringify(e.response.data.errors, null, 2);
			} else if (e.request) {
				error = 'Tank not moved to sign off , network Error';
			} else {
				error = 'Tank not moved to sign off , unknown Error';
			}
			new Toast().makeToast(error, 'Error moving tank to sign off', 'danger', false);
			this.submitStatus = 'ERROR';
			return;
		}

		setTimeout(() => {
			new Toast().makeToast('Tank moved to sign off', 'Tank  moved to sign off', 'success', false);
			this.$emit('loadProduct', this.tank.id);
			this.loadTank();
		}, 1000);

		// this.$router.push({ name: 'products.fuel.tank.sign-off', params: { tankId: tank.id } });
	}

	public async signOffTank(params: { modalId: string }) {
		let response;
		try {
			await new TanksApi().signoffTank(this.tank.id);
		} catch (e) {
			let error;
			if (e.response) {
				error = 'Tank not Signed Off ' + JSON.stringify(e.response.data.errors, null, 2);
			} else if (e.request) {
				error = 'Tank not Signed Off, network Error';
			} else {
				error = 'Tank not Signed Off, unknown Error';
			}
			new Toast().makeToast(error, 'Error Signing Off Tank', 'danger', false);
			this.submitStatus = 'ERROR';
			return;
		}
		setTimeout(() => {
			new Toast().makeToast('Tank  Signed Off', 'Tank  Signed Off', 'success', false);
			this.$emit('loadProduct', this.tank.id);
			this.loadTank();
			this.$bvModal.hide(params.modalId);
		}, 1000);
	}

	public reload() {
		setTimeout(() => {
			this.$emit('loadProduct', this.tank.id);
			this.loadTank();
		}, 1000);
	}
	// this.$router.push({ name: 'products.fuel.tank.sign-off', params: { tankId: tank.id } });
}
